import { render, staticRenderFns } from "./solutionItem.vue?vue&type=template&id=1029a6b3&functional=true&"
import script from "./solutionItem.vue?vue&type=script&lang=ts&"
export * from "./solutionItem.vue?vue&type=script&lang=ts&"
import style0 from "./solutionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports